import { render, staticRenderFns } from "./BetaDetail.vue?vue&type=template&id=a120e064&"
import script from "./BetaDetail.vue?vue&type=script&lang=js&"
export * from "./BetaDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports